module.exports = __webpack_public_path__ + "static/img/13_old.8b91dece.png";